const websiteConfig = {
    websiteTitle: "Robase - External services for Roblox experiences",
    websiteDescription: "Robase is the external service provider for your Roblox experiences. We offer databases, logs, analytics, application centers and more.",
    websiteImage: "/assets/img/logos/robase_v2_dark.png",
    websiteUrl: "https://robase.app/"
};

export default websiteConfig;
